<template>
  <div>
    <el-drawer
      :title="drawertitleview"
      :append-to-body="true"
      :visible.sync="drawer"
      size="45%"
    >
      <span style="position: relative; top: 15px">
        <el-form :model="sensororm" label-width="120px" class="demo-ruleForm">
          <el-form-item
            label="Valor de sensor"
            prop="vehicleBrand"
            style="width: 505px"
          >
            <el-input v-model="sensororm.valuesensor"></el-input>
          </el-form-item>
          <el-form-item
            label=" Galones Combustible"
            prop="vehicleModel"
            style="width: 505px"
          >
            <el-input-number
              v-model.number="Amountfuel"
              :min="0"
              :max="5000"
              style="position: relative; top: 15px"
            ></el-input-number>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="editedatasensor"
              >Guardar</el-button
            >
            <el-button @click="drawer = false">Cancelar</el-button>
          </el-form-item>
        </el-form>
      </span>
    </el-drawer>

    <rabbey-table3
      ref="tablevehiclesensor"
      :loading="loading"
      :border="true"
      :stripe="true"
      :data="datasensor"
      :columns="columnsSensor"
      :actions="actionssensor"
      @rtable-push-action="handlePushAction2"
    />
  </div>
</template>

<script>
export default {
  name: "vehiclesensor",

  props: {
    vehicleIdT: {
      type: Number
    }
  },
  data() {
    return {
      loading: false,
      drawer: false,
      datasensor: [],
      vehicleId: 0,
      sensorId: 0,
      drawertitleview: "",
      sensororm: {
        valuesensor: ""
      },

      //   rules: {
      //     vehicleBrand: [
      //         { required: true, message: 'Por Favor rellenar el campo', trigger: 'blur' },
      //       ],
      //     },

      Amountfuel: 0,
      columnsSensor: [
        // {
        //   prop: "sensorId",
        //   label: "Id",
        //   minWidth: 100,
        //   fixed: true
        // },
        {
          prop: "vehicle_Id",
          label: "vehiculo Id",
          minWidth: 100,
          fixed: true
        },
        {
          prop: "value_sensor",
          label: "Valor del sensor",
          minWidth: 100,
          fixed: true
        },
        {
          prop: "Amount_fuel",
          label: "Cantidad de galones de Combustible",
          minWidth: 100,
          fixed: true
        }
      ],

      actionssensor: [
        {
          icon: "el-icon-edit",
          label: "Editar",
          command: "edite"
        }
      ]
    };
  },

  created() {
    this.getsensor();
  },

  methods: {
    handlePushAction2(command) {
      switch (command.command) {
        case "edite":
          this.drawer = true;
          this.sensorId = command.row.sensorId;
          // console.log('klk id sensor',this.sensorId);
          this.drawertitleview = " Editar Sensores y Combustible";
          this.sensororm = {
            valuesensor: command.row.value_sensor
          };
          this.Amountfuel = command.row.Amount_fuel;
          break;

        default:
          break;
      }
    },

    getsensor() {
      this.loading = true;
      this.$http
        .get("/api/Proyects/Getvehiclesensor", {
          params: {
            vehicleId: this.vehicleIdT
          }
        })
        .then((response) => {
          this.datasensor = response.data;
          //    console.log("klk data",this.datasensor);
        })
        .finally(() => (this.loading = false));
    },

    editedatasensor() {
      let self = this;
      var datasensor = {
        sensorId: this.sensorId,
        value_sensor: this.sensororm.valuesensor,
        Amount_fuel: this.Amountfuel
      };
      self.$http
        .post("/api/Proyects/EditeSensor", datasensor)
        .then(() => {
          self.$message({
            type: "success",
            message: "Sensor  y Combustible se edito  correctamente"
          });

          self.$emit("success");
        })
        .catch((err) => {
          self.$message({ type: "error", message: err.message });
          console.log("error");
        })
        .finally(() => {
          // self.count = 0;
          self.sensororm = {};
          (self.Amountfuel = 0), (self.drawer = false);
          this.getsensor();
        });
    }
  },

  watch: {
    vehicleIdT() {
      this.getsensor();
    }
  }
};
</script>

<style></style>
